<template>
    <div class="container-fluid">
        <Breadcrumb title="Users" button-url="usersCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <input v-model="userSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by username">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="userList.length > 0">
                                <div class="table-responsive">
                                    <table class="table" id="emailsListTable">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Username</th>
                                            <th>Email</th>
                                            <th>Email Lists</th>
                                            <th>is Active</th>
                                            <th>Profit Rate</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(user, index) in userList" :key="index">
                                            <td :id="'id-' + index" class="align-middle">{{user.id}}</td>
                                            <td class="align-middle">{{user.username}}</td>
                                            <td class="align-middle">{{user.email}}</td>
                                            <td class="align-middle">
                                                <span class="px-3 badge"
                                                      v-bind:class="{'badge-light': user.emailLists.length ===0, 'badge-info': user.emailLists.length >0}">
                                                    {{user.emailLists.length}}
                                                </span>
                                            </td>
                                            <td class="align-middle">
                                                <toggle-button :value="user.isActive" sync color="#00c292"
                                                               @change="userStatusToggle(user)"
                                                               :labels="{checked: 'Yes', unchecked: 'No'}"
                                                               :height="26" :width="52">

                                                </toggle-button>
                                            </td>
                                            <td class="align-middle">{{user.profitRate}}%</td>
                                            <td class="align-middle">
                                                <router-link :to="{ name: 'usersEdit', params: { id: user.id }}"
                                                             class="btn btn-info btn-sm">
                                                    <i class="fa fa-cog"></i> Manage
                                                </router-link>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "../services/UserService";
    import Swal from 'sweetalert2'
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';

    export default {
        name: 'Users',
        components: {
            Breadcrumb,
            Preloader
        },
        mixins: [ paginateMixin ],
        data() {
            return {
                userList: [],
                userSearch: null,
                loading: false,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                totalItems: 0,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        },
        methods: {
            search() {
                this.getItems(this.page = 1);
            },
            getItems: function (pageNum) {
                this.loading = true;
                UserService.getUsers(pageNum, this.perPage, this.userSearch).then(response => {
                    this.userList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            userStatusToggle(user) {
                let userData = {
                    username: user.username,
                    email: user.email,
                    password: user.password,
                    isActive: !user.isActive
                };
                UserService.updateUser(user.id, userData).then(response => {
                    if (response.status === 200) {
                        this.getItems(this.page);
                    }
                }).catch(error => {
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    })
                });
            },
        }
    }
</script>

<style scoped>

</style>